import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';
import { lovCacheUtils } from '../../../common/api/lovApiSlice';

export const useAuthWithLov = () => {
  const dispatch = useDispatch();
  
  // Watch auth state
  const { isAuthenticated, userId, username, accessToken } = useSelector((state: RootState) => ({
    isAuthenticated: state.auth?.isAuthenticated || false,
    userId: state.auth?.userId || '',
    username: state.auth?.username || '',
    accessToken: state.auth?.accessToken || '',
  }));

  // Track previous auth state to detect login/logout
  const prevAuthState = useSelector((state: RootState) => state.auth?.isAuthenticated);

  // Handle login - prefetch LOV data
  useEffect(() => {
    if (isAuthenticated && userId && accessToken) {
      console.log('🔐 User authenticated, refreshing LOV data for:', username);
      // Invalidate existing cache and fetch fresh data
      lovCacheUtils.invalidateLovCache(dispatch, userId);
      // Prefetch fresh LOV data
      setTimeout(() => {
        lovCacheUtils.prefetchLovData(dispatch, userId);
      }, 100);
    }
  }, [isAuthenticated, userId, username, accessToken, dispatch]);

  // Handle logout - clear LOV cache
  useEffect(() => {
    if (!isAuthenticated && prevAuthState) {
      console.log('🚪 User logged out, clearing LOV cache');
      // Clear all LOV cache data on logout
      lovCacheUtils.clearLovCache(dispatch);
    }
  }, [isAuthenticated, prevAuthState, dispatch]);

  return {
    isAuthenticated,
    userId,
    username,
    // Utility functions for manual cache management
    refreshLovData: () => {
      console.log('🔄 Manually refreshing LOV data for:', username);
      lovCacheUtils.invalidateLovCache(dispatch, userId);
      lovCacheUtils.prefetchLovData(dispatch, userId);
    },
    clearCache: () => lovCacheUtils.clearLovCache(dispatch),
  };
}; 